'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMStatBlock = function WMStatBlock(_ref) {
	var title = _ref.title,
	    subtitle = _ref.subtitle,
	    titleStyle = _ref.titleStyle,
	    subtitleStyle = _ref.subtitleStyle;

	return _react2.default.createElement(
		'div',
		{
			style: _styles2.default.container,
			className: 'wm-stat__container'
		},
		_react2.default.createElement(
			'div',
			{
				style: [_styles2.default.subtitle, subtitleStyle],
				className: 'wm-stat__subtitle'
			},
			subtitle
		),
		_react2.default.createElement(
			'div',
			{
				style: [_styles2.default.title, titleStyle],
				className: 'wm-stat__title'
			},
			title
		)
	);
};

var _default = (0, _radium2.default)(WMStatBlock);

exports.default = _default;


WMStatBlock.propTypes = {
	title: _propTypes.PropTypes.string.isRequired,
	subtitle: _propTypes.PropTypes.string,
	titleStyle: _propTypes.PropTypes.object, // eslint-disable-line
	subtitleStyle: _propTypes.PropTypes.object // eslint-disable-line
};

WMStatBlock.defaultProps = {
	subtitle: ''
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(WMStatBlock, 'WMStatBlock', 'src/components/WMStat/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMStat/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMStat/index.js
// module id = UUBb
// module chunks = 62 63